import React from 'react';
import './TechSupportLine.scss';
import Grid from "@mui/material/Grid";

const TechSupportLine = () => {
    return (
        <div>
            <h3 className="sectionTitle center">Tech Support Line</h3>
            <Grid container justifyContent="center" alignItems="center" spacing={2}>
                <Grid item xs={12} lg={6} style={{ wordBreak: "break-word"}}>
                  For technical assistance with this application , or for help with your username and password, call our IT Service Desk
                    <a href="tel:978-281-9188">(978) 281-9188</a>.
                </Grid>
                <Grid item xs={12}>
                </Grid>
            </Grid>
        </div>
    );
}

export default TechSupportLine;
